import { render, staticRenderFns } from "./Sellers.vue?vue&type=template&id=6a21dd22&scoped=true"
import script from "./Sellers.vue?vue&type=script&lang=js"
export * from "./Sellers.vue?vue&type=script&lang=js"
import style0 from "./Sellers.vue?vue&type=style&index=0&id=6a21dd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a21dd22",
  null
  
)

export default component.exports